export default __webpack_public_path__ + "static/media/ERRIN_family_comic.18c4b2a7.pdf";